import { render } from "./person-military-detail.vue?vue&type=template&id=ea7e8754"
import script from "./person-military-detail.vue?vue&type=script&lang=js"
export * from "./person-military-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__